import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#2c3e50',
      color: '#ffffff',
      padding: '2rem 0',
      marginTop: '3rem'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: '0 2rem'
      }}>
        {/* Contact Information */}
        <div style={{ flex: 1, minWidth: '250px', marginBottom: '1.5rem' }}>
          <h3 style={{ marginBottom: '1rem', fontSize: '1.2rem', color: 'white' }}>
            Контактна информация
          </h3>
          <p style={{ marginBottom: '0.5rem' }}>
            <span style={{ fontWeight: 'bold' }}>Телефон:</span> 0885 339138
          </p>
          <p style={{ marginBottom: '0.5rem' }}>
            <span style={{ fontWeight: 'bold' }}>Имейл:</span> ethnobroderybg@gmail.com
          </p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: 1, minWidth: '250px', marginBottom: '1.5rem' }}>
          <h3 style={{ marginBottom: '1rem', fontSize: '1.2rem', color: '#00966e' }}>
            Полезни връзки
          </h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <Link to="/privacy-policy" style={{ color: '#00966e', textDecoration: 'none', transition: 'color 0.3s' }}>
                Политика за поверителност
              </Link>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <Link to="/contact" style={{ color: '#00966e', textDecoration: 'none', transition: 'color 0.3s' }}>
                Контакти
              </Link>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <Link to="/about" style={{ color: '#00966e', textDecoration: 'none', transition: 'color 0.3s' }}>
                За нас
              </Link>
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div style={{ flex: 1, minWidth: '250px', marginBottom: '1.5rem' }}>
          <h3 style={{ marginBottom: '1rem', fontSize: '1.2rem', color: 'red' }}>
            Последвайте ни
          </h3>
          {/* Facebook Link */}
          <div style={{ marginBottom: '1rem' }}>
            <a
              href="https://www.facebook.com/EthnoBrodery/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'red', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
              </svg>
              <span style={{ marginLeft: '0.5rem' }}>Facebook</span>
            </a>
          </div>
          {/* Instagram Link */}
          <div>
            <a
              href="https://www.instagram.com/ethnobrodery/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'red', textDecoration: 'none', display: 'flex', alignItems: 'center' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span style={{ marginLeft: '0.5rem' }}>Instagram</span>
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div style={{
        textAlign: 'center',
        marginTop: '2rem',
        paddingTop: '1rem',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 2rem'
      }}>
        <p style={{ margin: 0, padding: 0 }}>&copy; 2025 Ethnobrodery. Всички права запазени.</p>
        <p style={{ margin: 0, padding: 0, fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.7)' }}>
          Направено от <a href="https://myaibuilder.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#00966e', textDecoration: 'none' }}>Myaibuilder</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer; 